import { Button, StyledTableCell, Table, TableContainer } from '../../../../components';
import { Cell, Column, Row, TableBody, TableHeader } from '@react-stately/table';
import { EmptyMessage } from './EmptyMessage';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdateMaterialResponse } from '../../../../types';
import type { FC } from 'react';

interface IMaterialsTableProps {
  materials: Array<IUpdateMaterialResponse>;
  onRemove: (itemId: number) => void;
}

export const MaterialTable: FC<IMaterialsTableProps> = ({ materials, onRemove }) => {
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  return (
    <TableContainer className={'w-full'}>
      <Table selectionMode={'single'}>
        {/* HEADER */}
        <TableHeader>
          <Column>
            <StyledTableCell isHeader>{localization.translate('materialTable.nameHeader')}</StyledTableCell>
          </Column>
          <Column>
            <StyledTableCell isHeader isNumeric>
              {localization.translate('materialTable.quantityHeader')}
            </StyledTableCell>
          </Column>
          <Column>{''}</Column>
        </TableHeader>
        {/* BODY */}
        <TableBody>
          {materials.map((material, i) => (
            <Row key={i}>
              <Cell>
                <StyledTableCell>{material.name}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>{material.qty}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>
                  <Button
                    buttonProps={{ onPress: () => onRemove(material.itemId) }}
                    size={'sm'}
                    variant={'link'}
                  >
                    {localization.translate('actions.Remove')}
                  </Button>
                </StyledTableCell>
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>

      {/* EMPTY MESSAGE */}
      {materials.length === 0 && (
        <EmptyMessage>{localization.translate('materialTable.emptyMessage')}</EmptyMessage>
      )}
    </TableContainer>
  );
};